import React from 'react';

const DashboardPage: React.FC = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-4">Hoş Geldiniz Şef!</h1>
      <p className="text-blue-200">Burası "Sky Command" kontrol merkeziniz. Soldaki menüden içerikleri yönetmeye başlayabilirsiniz.</p>
    </div>
  );
};

export default DashboardPage;
